import React from 'react';
import { ConfigProvider } from 'antd';
import GlobalStyle from './styles/GlobalStyle';
import 'typeface-mulish';
import 'typeface-inter';
import { AppRouter } from './components/router/AppRouter';
import { useAutoNightMode } from './hooks/useAutoNightMode';
import { useThemeWatcher } from './hooks/useThemeWatcher';
import { useAppSelector } from './hooks/reduxHooks';
import { themeObject } from './styles/themes/themeVariables';
import 'moment/locale/pt';
import ptBR from 'antd/lib/locale/pt_BR';
import enUS from 'antd/lib/locale/en_US';
import { useLanguage } from './hooks/useLanguage';

const App: React.FC = () => {
  const { language } = useLanguage();
  const theme = useAppSelector((state) => state.theme.theme);

  useAutoNightMode();

  useThemeWatcher();

  return (
    <>
      <meta name="theme-color" content={themeObject[theme].primary} />
      <GlobalStyle />
      <ConfigProvider locale={language === 'br' ? ptBR : enUS}>
        <AppRouter />
      </ConfigProvider>
    </>
  );
};

export default App;
